import { Trans, useTranslation } from 'next-i18next';
import { ReactNode } from 'react';
import { Box, Text } from '@bridebook/ui';
import AsSeenIn from '@bridebook/web/app-shared/components/landing/as-seen-in/as-seen-in';
import styles from './reviews.style';

interface IProps {
  isMobile: boolean;
  suggestions: ReactNode;
  reviewModal: ReactNode;
}

export const Reviews = ({ isMobile, suggestions, reviewModal }: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box style={styles.wrapper}>
        <Box style={styles.topWrap}>
          <Box style={styles.mainBox}>
            <Text as="h2" style={styles.mainTitle}>
              {isMobile ? (
                <Trans ns="supplier" i18nKey="review.page.mobile.mainTitle">
                  Review your wedding
                  <br />
                  venue & suppliers
                </Trans>
              ) : (
                t('supplier:review.page.desktop.mainTitle')
              )}
            </Text>
            <Text as="h3" style={styles.secondTitle}>
              {t('supplier:review.page.secondTitle')}
            </Text>
            <Box style={styles.suggestionsWrap}>{suggestions}</Box>
          </Box>
        </Box>
        <Box style={styles.asSeenWrap}>
          <AsSeenIn />
        </Box>
      </Box>
      {reviewModal}
    </>
  );
};
